import { AccredibleAvatarComponentModule } from '@accredible-frontend-v2/new-components/avatar';
import { AccredibleIconComponentModule } from '@accredible-frontend-v2/new-components/icon';
import { AccredibleAccountsRedirectionService } from '@accredible-frontend-v2/services/accounts-redirection';
import { AccredibleAuthenticationApiService } from '@accredible-frontend-v2/services/authentication';
import { AccredibleUserApiService } from '@accredible-frontend-v2/services/user';
import { CdkMenu, CdkMenuItem, CdkMenuTrigger } from '@angular/cdk/menu';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  standalone: true,
  selector: 'ler-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    RouterModule,
    TranslocoModule,
    AccredibleAvatarComponentModule,
    AccredibleIconComponentModule,
    CdkMenu,
    CdkMenuItem,
    CdkMenuTrigger,
  ],
})
export class HeaderComponent {
  private readonly _userApi = inject(AccredibleUserApiService);
  private readonly _accountsRedirection = inject(AccredibleAccountsRedirectionService);
  private readonly _authenticationApi = inject(AccredibleAuthenticationApiService);

  readonly user = toSignal(this._userApi.user$);
  readonly accountsLoginUrl = this._accountsRedirection.getLoginUrlHref('ler');

  logout(): void {
    this._authenticationApi.logout().subscribe({
      next: () => {},
      error: () => {},
    });
  }
}
